import { Title, Gender } from "../types";

export const TITLES: Title[] = ["Mr", "Mrs", "Ms", "Dr"];
export const GENDERS: Gender[] = ["Male", "Female", "Other"];